import { useCallback, useRef, useState } from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';
import { getMessage } from '@gef-ui/localization/messages';
import MenuPopover from '@gef-ui/material/components/MenuPopover';
import CircleQuestionSolid from '@gef-ui/material-icons/CircleQuestionSolid';

import { KCL_MENU_HELPEDK, KCL_MENU_HELPIDK } from 'features/common/acl/constants';
import { getAvailableHelpLinks } from 'features/views/navbar/selectors';
import windowOpen from 'utils/windowOpen';

const Help = () => {
	const [opened, setIsOpened] = useState(false);
	const hasPermissionToIdkHelp = useSelector((state) => hasPermissionByIds(state)(KCL_MENU_HELPIDK));
	const hasPermissionToEdkHelp = useSelector((state) => hasPermissionByIds(state)(KCL_MENU_HELPEDK));
	const { baseLinks, additionalLinks } = useSelector((state) => getAvailableHelpLinks(state));

	const handleOpen = useCallback((event) => {
		setIsOpened(event.currentTarget);
	}, []);

	const handleClose = useCallback(() => {
		setIsOpened(null);
	}, []);

	const openHelpSite = useCallback(
		(instructionLink) => () => {
			windowOpen(instructionLink);
			handleClose();
		},
		[handleClose],
	);

	const buttonRef = useRef();

	const generateMenuItems = useCallback(
		(links) =>
			links.map((item) => (
				<MenuItem onClick={openHelpSite(item.link)}>
					<Typography variant="body2">{getMessage(item.label)}</Typography>
				</MenuItem>
			)),
		[openHelpSite],
	);

	if (!hasPermissionToIdkHelp && !hasPermissionToEdkHelp) {
		return null;
	}

	return (
		<>
			<ButtonBase
				sx={{
					svg: {
						fontSize: (theme) => theme.gkcl?.svgIcon?.size35,
					},
				}}
				onClick={handleOpen}
				ref={buttonRef}
			>
				<CircleQuestionSolid />
			</ButtonBase>
			<MenuPopover open={Boolean(opened)} onClose={handleClose} anchorEl={buttonRef.current}>
				<Stack>
					{generateMenuItems(baseLinks)}
					{!isNilOrEmpty(additionalLinks) && (
						<>
							<Divider />
							{generateMenuItems(additionalLinks)}
						</>
					)}
				</Stack>
			</MenuPopover>
		</>
	);
};

export default Help;
